// src/pages/Home.js
import React from 'react';
import heroImage from '../assets/sicilian-hero.jpg'; // Assicurati che il percorso sia corretto
import sicilianProduct from '../assets/sicilian-product.jpg'
import sicily from '../assets/sicily.jpg'
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="container-fluid p-0">
      {/* Sezione Hero: contenitore con altezza fissa e overflow hidden */}
      <section className="position-relative">
        <div
          style={{
            height: '70vh',
            overflow: 'hidden',
            backgroundColor: '#FFFFFF' // Colore di sfondo per eventuali barre laterali
          }}
        >
          <img
            src={heroImage}
            alt="Eccellenze Siciliane"
            className="img-fluid w-100"
            style={{
              height: '100%',
              objectFit: 'contain'
            }}
          />
        </div>
      </section>

      {/* Call-to-Action */}
      <section className="py-5 bg-success text-white text-center">
        <div className="container">
          <h2 className="display-5 fw-bold">Esplora le Eccellenze Siciliane</h2>
          <p className="lead">
            Scopri prodotti agricoli e agroalimentari di alta qualità direttamente dalla Sicilia
          </p>
          <Link to="/products" className="btn btn-outline-light btn-lg mt-3">
              Scopri i Prodotti
            </Link>

        </div>
      </section>

      {/* Sezione Introduzione */}
      <section className="container my-5">
        <div className="row align-items-center">
          <div className="col-md-6">
            <h3 className="mb-4">Il Progetto "Io Vendo Siciliano"</h3>
            <p>
              "Io Vendo Siciliano" nasce per valorizzare e promuovere i prodotti agricoli e agroalimentari della Sicilia
              sui mercati internazionali, attraverso la creazione di un marchio distintivo. L’obiettivo è dare visibilità
              alle eccellenze siciliane, legate alla qualità, alla sostenibilità e al patrimonio culturale.
            </p>
            <p>
              Il progetto mira a rafforzare le filiere produttive e a sostenere i produttori locali, migliorando la competitività
              e incentivando lo sviluppo socio-economico delle aree rurali.
            </p>
          </div>
          <div className="col-md-6">
            <img
              src={sicilianProduct}
              alt="Prodotti Siciliani"
              className="img-fluid rounded shadow"
            />
          </div>
        </div>
      </section>

      {/* Sezione Territorio e Tradizioni */}
      <section className="container my-5">
        <div className="row align-items-center flex-row-reverse">
          <div className="col-md-6">
            <h3 className="mb-4">Territorio e Tradizioni</h3>
            <p>
              Il progetto valorizza l’identità culturale della Sicilia, promuovendo le tradizioni agricole, la trasformazione
              agroalimentare e il settore della pesca. Le iniziative esalteranno il patrimonio locale, contribuendo a preservare
              le radici culturali della regione.
            </p>
          </div>
          <div className="col-md-6">
            <img
              src={sicily}
              alt="Territorio e Tradizioni"
              className="img-fluid rounded shadow"
            />
          </div>
        </div>
      </section>

      {/* Sezione Obiettivi e Impatto */}
      <section className="container my-5">
        <h3 className="mb-4 text-center">Obiettivi e Impatto</h3>
        <div className="row">
          <div className="col-md-4">
            <div className="card border-0 shadow-sm">
              <div className="card-body text-center">
                <i className="fas fa-seedling fa-3x text-success mb-3"></i>
                <h5 className="card-title">Promozione</h5>
                <p className="card-text">
                  Valorizzare l’eccellenza agroalimentare siciliana attraverso un marchio distintivo, favorendo la conoscenza dei prodotti in tutto il mondo.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 shadow-sm">
              <div className="card-body text-center">
                <i className="fas fa-handshake fa-3x text-success mb-3"></i>
                <h5 className="card-title">Collaborazione</h5>
                <p className="card-text">
                  Rafforzare le filiere produttive locali e facilitare la collaborazione tra produttori, trasformatori e distributori.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 shadow-sm">
              <div className="card-body text-center">
                <i className="fas fa-chart-line fa-3x text-success mb-3"></i>
                <h5 className="card-title">Sviluppo</h5>
                <p className="card-text">
                  Creare nuove opportunità di crescita per giovani, donne e comunità locali, aumentando la competitività internazionale.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
